import React, { useCallback, useMemo, useState } from 'react';
import debounce from '@mui/material/utils/debounce';
import SearchField from './SearchField';

interface SearchFilterProps {
  onChange: (s: string) => unknown;
}

const SearchFilter: React.FC<SearchFilterProps> = ({ onChange }) => {
  const [text, setText] = useState<string>('');
  const handleChange = useMemo(
    () => debounce((v: string) => onChange(v), 1000),
    [onChange]
  );
  const handleText = useCallback(
    (value: string) => {
      setText(value);
      handleChange(value);
    },
    [setText, onChange]
  );
  return (
    <div className="search_bar__wrapper">
      <h1 className="heading-page">Feedback Management</h1>
      <SearchField
        size="large"
        value={text}
        onChange={handleText}
        placeholder="Search Reports"
        maxWidth={690}
      />
    </div>
  );
};

export default React.memo(SearchFilter);
